import { Hero } from '@/components/Hero';

export function LandingPage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
    </div>
  );
}

